import React from 'react';
import { Download, Plus } from 'lucide-react';

interface ExportButtonProps {
  onClick: () => void;
  label?: string;
}

interface AddAssetButtonProps {
  onClick: () => void;
  label?: string;
  disabled?: boolean;
}

export const ExportButton: React.FC<ExportButtonProps> = ({ 
  onClick, 
  label = 'Export CSV' 
}) => {
  return (
    <button
      onClick={onClick}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-lg bg-gray-800/50 text-gray-300 hover:bg-gray-800/80 transition-colors disabled:bg-gray-700 disabled:text-gray-400 disabled:cursor-not-allowed"
      disabled
    >
      <Download className="h-4 w-4" />
      <span>{label}</span>
    </button>
  );
};

export const AddAssetButton: React.FC<AddAssetButtonProps> = ({ 
  onClick, 
  label = 'Add Asset',
  disabled = true
}) => {
  return (
    <button 
      onClick={onClick}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-lg transition-colors disabled:bg-gray-700 disabled:text-gray-400 ${disabled ? "cursor-not-allowed" : ""} bg-blue-500 text-white hover:bg-blue-600`}
      disabled={disabled}
    >
      <Plus className="h-4 w-4" />
      <span>{label}</span>
    </button>
  );
};